import { useEffect } from 'react';
import { useLens } from '../app/lens';
import { updateHousehold } from '../data/api';
import { useFamily } from '../data/family';
import { searchPlaces } from './geo';

/**
 * Families from before 1.24 have a home town without its federal state, so the calendar showed
 * no school holidays (Mike, 19.10.: "Es sind aktuell Ferien, das sehe ich noch nicht"). A
 * parent's device looks the town up once – the same place search as in the settings, only the
 * town's name goes out – and stores the state. No clicking for the family.
 */
export function useEnsureRegion() {
  const f = useFamily();
  const lens = useLens();
  const loc = f.household?.location;
  const missing = !!loc && !loc.region;
  useEffect(() => {
    if (!lens.canParent || !missing || !loc) return;
    let stopped = false;
    void searchPlaces(loc.name)
      .then((hits) => {
        if (stopped) return;
        // the hit at the stored coordinates (rounded to ~1 km), never just the first namesake
        const near = hits
          .filter((h) => h.region)
          .map((h) => ({
            h,
            d: Math.abs(h.latitude - loc.latitude) + Math.abs(h.longitude - loc.longitude),
          }))
          .sort((a, b) => a.d - b.d)[0];
        if (near && near.d < 0.3) {
          return updateHousehold(f.householdId, { location: { ...loc, region: near.h.region } });
        }
      })
      .catch(() => undefined);
    return () => {
      stopped = true;
    };
  }, [lens.canParent, missing, loc, f.householdId]);
}
